import { extractMediaUrls } from '../sync/diff.js';
import { fetchAndCache } from './media-cache.js';
import { logInfo, logWarn } from '../state/log-store.js';
import { MEDIA_PREFETCH_CONCURRENCY } from '../config.js';

/**
 * Prefetch media URLs with limited concurrency (rate-friendly).
 * @param {string[]} urls
 * @param {number} [concurrency]
 */
export async function prefetchMediaUrls(urls, concurrency = MEDIA_PREFETCH_CONCURRENCY) {
  const unique = [...new Set(urls.filter(Boolean))];
  if (!unique.length) return { ok: 0, failed: 0 };

  let ok = 0;
  let failed = 0;
  let index = 0;

  async function worker() {
    while (index < unique.length) {
      const url = unique[index++];
      try {
        await fetchAndCache(url);
        ok += 1;
      } catch (e) {
        failed += 1;
        logWarn('Media prefetch failed', { url, error: e.message });
      }
    }
  }

  const workers = Array.from({ length: Math.min(concurrency, unique.length) }, () => worker());
  await Promise.all(workers);
  logInfo('Media prefetch batch done', { total: unique.length, ok, failed });
  return { ok, failed };
}

/** @param {object | null | undefined} program */
export async function prefetchProgramMedia(program) {
  return prefetchMediaUrls(extractMediaUrls(program));
}
